import React from 'react';
import { MessageSquare, X } from 'lucide-react';

interface BroadcastMessageProps {
  message: {
    message: string;
    createdAt: Date;
    createdBy: string;
  };
  onClose: () => void;
}

export default function BroadcastMessage({ message, onClose }: BroadcastMessageProps) {
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black bg-opacity-50 z-40 animate-fadeIn" onClick={onClose} />

      {/* Modal Box */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-white rounded-xl shadow-2xl max-w-md w-full animate-scaleIn">
          {/* Header */}
          <div className="flex items-center justify-between p-4 border-b border-slate-200">
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0 w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                <MessageSquare className="h-5 w-5 text-blue-600" />
              </div>
              <h3 className="text-lg font-semibold text-slate-800">
                Message from Admin
              </h3>
            </div>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
              aria-label="Close"
            >
              <X className="h-5 w-5" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6">
            <p className="text-slate-700 leading-relaxed whitespace-pre-wrap">
              {message.message}
            </p>
            <p className="mt-4 text-xs text-slate-400">
              {message.createdAt.toLocaleDateString()}
            </p>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 bg-slate-50 rounded-b-xl flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-colors"
            >
              Got it
            </button>
          </div>
        </div>
      </div>
    </>
  );
}